import { useState } from 'react';
import { TruckIcon, ShoppingCartIcon, CurrencyDollarIcon, DevicePhoneMobileIcon, ClockIcon, ShieldCheckIcon, CheckCircleIcon, CpuChipIcon, DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';
import logo from "../assets/logoNA.svg";
import log from "../assets/process.jpg"

export default function HowItWorks() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-sky-500 to-white">
            <nav className="fixed w-full bg-white/90 backdrop-blur-lg shadow-lg z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20"> {/* Increased height */}
                        <div className="flex-shrink-0 flex items-center space-x-3">
                        <div className="relative w-16 h-16">
                                <img src={logo} alt='' />
                            </div>
                            <a href='/' className="text-3xl p-0 m-0 font-bold bg-gradient-to-r from-blue-900 to-sky-600 bg-clip-text text-transparent no-underline leading-tight pb-1">
                                NexusAgents
                            </a>
                        </div>

                        {/* Desktop Menu - Increased text size */}
                        <div className="hidden md:flex space-x-8">
                            <a href="services" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Services</a>
                            <a href="how" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">How It Works</a>
                            <a href="contact" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Contact</a>
                        </div>
                        {/* <a href="login" className="hidden md:flex bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a>
                        <a href="login" className="md:hidden bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a> */}

                        {/* Mobile Menu Button - Larger size */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="md:hidden p-3 rounded-lg text-blue-900 hover:bg-sky-50"
                        >
                            <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu - Larger text */}
                {isMenuOpen && (
                    <div className="md:hidden px-4 pt-2 pb-4 space-y-2">
                        <a href="services" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Services</a>
                        <a href="how" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">How It Works</a>
                        <a href="contact" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Contact</a>
                    </div>
                )}
            </nav>
            {/* Hero Section */}

            <div className="pt-32" // px-4 sm:px-6 lg:px-8
            >
                <div className="text-center px-4 sm:px-6 lg:px-8">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                        How This Process Works
                    </h1>
                    <p className="text-xl text-sky-100 mb-8 max-w-3xl mx-auto">
                        Discover our seamless 4-step process that connects you with trusted local experts,
                        combining tech-smart solutions with human-centric service delivery.
                    </p>

                    {/* Key Benefits Grid */}
                    <div className="grid md:grid-cols-3 gap-8 mb-12 max-w-6xl mx-auto">
                        {[
                            { icon: ClockIcon, text: 'Average 45-min response time' },
                            { icon: ShieldCheckIcon, text: '100% verified service agents' },
                            { icon: CurrencyDollarIcon, text: 'Transparent upfront pricing' }
                        ].map((item, idx) => (
                            <div key={idx} className="flex items-center bg-white/10 p-4 rounded-xl">
                                <item.icon className="h-8 w-8 text-sky-300 mr-4" />
                                <span className="text-sky-100 text-lg">{item.text}</span>
                            </div>
                        ))}
                    </div>

                </div>
                <div className='mt-5 w-full flex justify-center'>
                    <img src={log} alt='' className='w-full' />
                </div>
            </div>

            {/* How It Works Section */}

            {/* Enhanced How It Works Section */}
            <div className="py-16 bg-sky-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">
                        Our Service Process Breakdown
                    </h2>

                    <div className="grid md:grid-cols-4 gap-8">
                        {[
                            {
                                step: '1',
                                title: 'Place Request',
                                icon: DocumentMagnifyingGlassIcon,
                                text: 'Initiate your request through:',
                                features: ['Google form', 'Phone call', 'WhatsApp'],//'Mobile app', 
                                note: '8:00 a.m. - 10:00 p.m. / 7 days'//'24/7 availability'
                            },
                            {
                                step: '2',
                                title: 'Agent Assignment',
                                icon: CpuChipIcon,
                                text: 'Our agency instantly:',
                                features: ['Verifies requirements', 'Check agent availability', 'Assign Service Agents'],
                                note: 'AI-powered matching'
                            },
                            {
                                step: '3',
                                title: 'Recieve Service',
                                icon: TruckIcon,
                                text: 'Experience real-time:',
                                features: ['Photo and Video updates', 'Chat with agent through whatsapp or call', 'Service modifications if required'], //'GPS tracking', 
                                note: 'Avg. 90-min completion'
                            },
                            {
                                step: '4',
                                title: 'Service Completion',
                                icon: CheckCircleIcon,
                                text: 'Final steps include:',
                                features: ['Digital receipt', 'Pay during or after Serviceas Required and agreed', 'UPI or Cash payment Mode', 'Service rating'],
                                note: '100% satisfaction guarantee'
                            }
                        ].map((step, idx) => (
                            <div key={idx} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                                <div className="flex items-center mb-4">
                                    <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center text-white text-xl font-bold mr-4">
                                        {step.step}
                                    </div>
                                    <step.icon className="h-8 w-8 text-blue-900" />
                                </div>
                                <h3 className="text-2xl font-semibold text-blue-900 mb-3">{step.title}</h3>
                                <p className="text-sm text-sky-600 font-medium">{step.note}</p>
                                <p className="text-gray-700 mb-4">{step.text}</p>
                                <ul className=" pl-5 list-disc space-y-2 mb-4  text-center">
                                    {step.features.map((feature, fIdx) => (
                                        <li key={fIdx} className="text-gray-600">{feature}</li>
                                    ))}
                                </ul>

                            </div>
                        ))}
                    </div>

                    {/* Process Timeline */}
                    <div className="mt-16 hidden md:block">
                        <div className="relative h-2 bg-sky-200 rounded-full">
                            <div className="absolute inset-0 flex justify-between">
                                {[...Array(4)].map((_, idx) => (
                                    <div key={idx} className="w-1/4">
                                        <div className="relative -top-3.5">
                                            <div className="h-8 w-8 bg-sky-600 rounded-full mx-auto"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="py-16 bg-gradient-to-r from-blue-900 to-sky-600">
                {/* <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">  </div> */}
                <div className="w-full grid md:grid-cols-3 gap-8 mx-auto my-5 text-center px-4 sm:px-6 lg:px-8">
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6 text-center">About NexusAgents</h2>
                        <p className="text-sky-100 mb-8 text-xl text-justify">
                            {/* At NexusAgents, we bridge the gap between busy lives and everyday necessities. As your trusted local service partner, we specialize in secure doorstep deliveries, personalized shopping assistance, and hassle-free errand management. Our network of vetted professionals combines tech-driven efficiency with human-centric care, handling everything from urgent document transfers to meticulous grocery runs. Beyond physical tasks, we empower businesses with administrative support and tech consultations, ensuring both homes and enterprises thrive. With transparent pricing, real-time tracking, and a commitment to reliability, we transform time-consuming chores into seamless experiences. NexusAgents isn’t just a service—it’s your extended team, redefining convenience in the modern world. */}
                            We’re your hyperlocal solution hub, offering secure transfers, deliveries, personal shopping, and errand services for busy lives. With tech-driven agents and vetted pros, we simplify tasks from grocery runs to business paperwork. Trusted reliability, transparent pricing—we turn chores into effortless moments.
                        </p>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Features</h2>
                        <ul className="list-unstyled space-y-4 text-center" aria-label="Quick links">
                            {/* <li><a href="refund" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Refund Policy</a></li> */}
                            <li><a href="terms" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Terms of Service</a></li>
                            <li><a href="privacy" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Convenience?</h2>
                        <p className="text-sky-100 mb-8 text-xl">Join hundreds of satisfied customers today!</p>
                        <div className="flex justify-center space-x-4">
                            {/* <a href='register' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors">
                                Sign Up Now
                            </a> */}
                            <a href='contact' className="border-2 border-white no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-blue-900 text-sky-100 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p>Copyright © 2025 NexusAgents. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}